import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Box, Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { IAlbumFormat } from "../../../../hooks/albumFormats";
import { Icon, IconType } from "../../../../icons";

export const AlbumFormatCard: FunctionComponent<IAlbumFormatCardProps> = ({
  albumFormat,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  return (
    <Card sx={{ height: 64, borderRadius: "20px" }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        <Card className={styles.defaultIcon}>
          <Icon type={IconType.ControlCamera} />
        </Card>
        <Stack className={styles.rightContainer} spacing={1}>
          <p className={styles.name}>{albumFormat.name}</p>
          <Stack direction="row">
            <Card sx={{ padding: 0.5 }}>
              <p className={styles.shortName}>{albumFormat.shortName}</p>
            </Card>
            <Box flexGrow={1} />
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IAlbumFormatCardProps {
  albumFormat: IAlbumFormat;
  selected?: boolean;
  onClick: () => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
